<div class="file-preview rounded-2">
  <div class="file-preview__header">
    <div class="file-preview__content">
      @if (data?.extra?.media === 'image') {
        <div class="file-preview__image">
          <img
            alt="Preview image"
            class="file-preview__image-content"
            data-e2e="UploadFilePreviewImage"
            [src]="data?.item" />
        </div>
      } @else if (data?.extra?.media === 'video') {
        <div class="file-preview__player">
          <!-- <bn-stream-live-stream-player
          customText="Go live from your encoder to start the event."
          data-e2e="LiveStreamPlayer"
          [cdnSecurity]="streamTokens()"
          [library]="library()"
          [livePreview]="true"
          [stream]="stream"
          [streamStatus]="streamFeedStatus"></bn-stream-live-stream-player> -->
        </div>
      } @else {
        Media type not specified
      }
    </div>
  </div>
</div>
